import cx from 'classnames';

import { COLORS } from './colors';

interface Props {
  text: string;
  color: keyof typeof COLORS;
}

const Tag = ({ text, color }: Props) => {
  return <div className={cx('w-fit rounded px-2 py-1 text-xs font-medium', COLORS[color])}>{text}</div>;
};

export default Tag;
